import { ApiFilter } from './ApiFilter';
import _ from "lodash";

export class ExistsFilter extends ApiFilter {
  static parse(object) {
    return new ExistsFilter(object.field);
  }

  field:string;

  constructor(field:string) {
    super('exists');
    this.field = field;
  }

  toPlainObject() {
    if (_.isEmpty(this.field)) {
      throw new Error('field is mandatory')
    }

    const result:any = super.toPlainObject();
    result.field = this.field;
    return result;
  }

  getCopy():ApiFilter {
    const apiFilter = new ExistsFilter(this.field);
    return apiFilter;
  }
}